import { render, staticRenderFns } from "./DocumentsBaseForm.vue?vue&type=template&id=7b91d11f&"
import script from "./DocumentsBaseForm.vue?vue&type=script&lang=js&"
export * from "./DocumentsBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsBaseForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports